import { Link } from 'react-router-dom'
import { useDashboard } from '../hooks/useDashboard'

/**
 * Admin-only "Pending Actions" callout — IDM Requests pending
 * confirmation count. Hidden for non-admins, hidden when the count
 * is loading, and hidden when the count is 0 (matches the legacy
 * dashboard's "no flicker" behavior per the dashboard-pending-actions
 * spec).
 *
 * Spec 4 / Group 9f — `request-center-dashboard.md` +
 * `dashboard-pending-actions.md` (relocated from legacy `/`).
 */
export function PendingActionsCallout() {
	const { isSuperAdminViewer, pendingIdmConfirmationQuery } = useDashboard()

	if (!isSuperAdminViewer) return null
	if (pendingIdmConfirmationQuery.isLoading || pendingIdmConfirmationQuery.isPending) return null
	const count = pendingIdmConfirmationQuery.data ?? 0
	if (count <= 0) return null

	return (
		<section aria-labelledby="pending-actions-heading" className="space-y-3">
			<h2 id="pending-actions-heading" className="text-xs font-semibold uppercase tracking-wider text-amber-500">
				Pending Actions
			</h2>
			<Link
				to="/idm-requests"
				className="block rounded-lg border border-amber-200 bg-amber-50 p-4 transition-all hover:ring-2 hover:ring-amber-300 hover:ring-offset-1"
			>
				<div className="flex items-center gap-3">
					<div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-amber-100">
						<span className="text-lg font-bold text-amber-700">{count}</span>
					</div>
					<div>
						<h3 className="text-sm font-semibold text-amber-800">IDM Requests pending confirmation</h3>
						<p className="text-xs text-amber-600">Requires your attention</p>
					</div>
				</div>
			</Link>
		</section>
	)
}
